import { connect } from 'react-redux';

import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { FOfferType } from '../../utils/category';
import { selectOfferType } from '../../actions/filters';
import { FilterOfferType, IFilterOfferTypeProps } from '../../components/FilterOfferType';
import { togglePopupAutoChangeToSuburban } from '../../reducers/modules/search/building_types';

type TFilterOfferTypeDispatchProps = Pick<IFilterOfferTypeProps, 'onSelect' | 'hidePopupAutoChangeToSuburban'>;

export function mapStateToProps(
  state: IApplicationState,
): Pick<IFilterOfferTypeProps, 'canShowPopupAutoChangeToSuburban'> {
  return {
    canShowPopupAutoChangeToSuburban: Boolean(state.buildingType.canShowPopupAutoChangeToSuburban),
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterOfferTypeDispatchProps {
  return {
    onSelect: (offerType: FOfferType) => dispatch(selectOfferType(offerType)),
    hidePopupAutoChangeToSuburban: () => {
      dispatch(togglePopupAutoChangeToSuburban(false));
    },
  };
}

export const FilterOfferTypeContainer = connect(mapStateToProps, mapDispatchToProps)(FilterOfferType);
